import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { colors, radius } from '../theme';

const API = 'https://api.sm-media.id';

// Persetujuan UGC (2026-10-21): proyek UGC yang diajukan editor; disetujui = dijadwalkan sesuai permintaan editor.
const ringkasJadwal = j => {
  const cs = (j && j.channel_schedules) || [];
  if (cs.length) {
    const rel = cs.filter(c => c.offset_min != null).length;
    return rel === cs.length ? `Bertahap: ${cs.length} channel, dihitung dari saat disetujui` : `Bertahap per channel (${cs.length} channel)`;
  }
  return j && j.scheduled_at ? `Satu jam untuk semua: ${new Date(j.scheduled_at).toLocaleString('id-ID', { dateStyle: 'medium', timeStyle: 'short' })} WIB` : 'Upload segera setelah disetujui';
};
function UgcApprovals({ onError, onChange }) {
  const [list, setList] = useState(null);
  const [busy, setBusy] = useState(null);
  const [tolak, setTolak] = useState(null), [alasan, setAlasan] = useState('');
  const [putar, setPutar] = useState(null);
  const muat = () => axios.get(`${API}/api/ugc/approvals`).then(r => { setList(r.data || []); onChange && onChange((r.data || []).length); }).catch(() => setList([]));
  useEffect(() => { muat(); }, []);
  const kirim = async (id, aksi, al) => {
    setBusy(id);
    try { await axios.post(`${API}/api/ugc/projects/${id}/persetujuan`, { aksi, alasan: al }); setTolak(null); setAlasan(''); muat(); }
    catch (e) { onError(e.response?.data?.error || 'Gagal memproses pengajuan UGC'); }
    setBusy(null);
  };
  if (!list || list.length === 0) return null;
  const tok = (() => { try { return localStorage.getItem('sm_token') || ''; } catch (e) { return ''; } })();
  return (
    <div style={{ marginTop: 24 }}>
      <h2 style={{ fontSize: 16, fontWeight: 700, color: colors.textPrimary, marginBottom: 10, display: 'flex', alignItems: 'center', gap: 6 }}>
        <i className="ti ti-movie" />Video UGC ({list.length})
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {list.map(j => (
          <div key={j.id} style={{ background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg, padding: 16 }}>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 10 }}>
              <div style={{ flex: '0 0 auto', width: 'min(100%, 320px)' }}>
                {putar === j.id
                  ? <video controls autoPlay preload="metadata" src={`${API}/api/ugc/preview/${j.id}?token=${tok}`} style={{ width: '100%', borderRadius: 8, display: 'block', background: '#000' }} />
                  : <button type="button" onClick={() => setPutar(j.id)} style={{ position: 'relative', width: '100%', aspectRatio: '16/9', borderRadius: 8, border: `1px solid ${colors.border}`, background: j.thumbnail_url ? `center/cover url(${API}${j.thumbnail_url})` : colors.bgCardMuted, cursor: 'pointer', padding: 0 }} aria-label="Putar pratinjau">
                      <i className="ti ti-player-play-filled" style={{ fontSize: 34, color: '#fff', textShadow: '0 2px 8px rgba(0,0,0,.6)' }} />
                    </button>}
              </div>
              <div style={{ flex: '1 1 220px', minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: 14, color: colors.textPrimary, marginBottom: 4 }}>{j.title || 'Tanpa Judul'}</div>
                <div style={{ fontSize: 11, color: colors.textSecondary, marginBottom: 6 }}>
                  Diajukan oleh <strong>{j.diajukan_nama || 'Tidak diketahui'}</strong> · {j.diajukan_at ? new Date(j.diajukan_at).toLocaleString('id-ID') : ''}
                  {j.duration_sec ? ` · ${Math.floor(j.duration_sec / 60)}:${String(j.duration_sec % 60).padStart(2, '0')}` : ''}
                </div>
                <div style={{ fontSize: 12, color: colors.textPrimary, marginBottom: 4 }}><i className="ti ti-calendar-time" /> {ringkasJadwal(j.persetujuan_jadwal)}</div>
                <div style={{ fontSize: 12, color: colors.textSecondary }}><i className="ti ti-brand-youtube" /> {(j.channels || []).length} channel: {(j.channels || []).join(', ') || '—'}</div>
                {j.description && <div style={{ fontSize: 12, color: colors.textSecondary, background: colors.bgCardMuted, borderRadius: 8, padding: 8, marginTop: 8, maxHeight: 60, overflow: 'auto' }}>{j.description}</div>}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => kirim(j.id, 'setujui')} disabled={busy === j.id}
                style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: 'none', background: busy === j.id ? colors.border : colors.success, color: '#FFFFFF', fontSize: 13, fontWeight: 700, cursor: busy === j.id ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                <i className="ti ti-check" style={{ fontSize: 15 }}></i>Setujui & jadwalkan
              </button>
              <button onClick={() => { setTolak(j); setAlasan(''); }} disabled={busy === j.id}
                style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: `1px solid ${colors.danger}`, background: 'transparent', color: colors.danger, fontSize: 13, fontWeight: 700, cursor: busy === j.id ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                <i className="ti ti-x" style={{ fontSize: 15 }}></i>Tolak
              </button>
            </div>
          </div>
        ))}
      </div>
      {tolak && (
        <div onClick={() => setTolak(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: colors.bgCard, borderRadius: radius.lg, padding: 24, maxWidth: 400, width: '100%' }}>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: colors.textPrimary, marginBottom: 6 }}>Tolak Video UGC</h2>
            <p style={{ fontSize: 12, color: colors.textSecondary, marginBottom: 14 }}>"{tolak.title || 'Tanpa Judul'}" tidak akan diupload. Alasan ini terlihat oleh editor, yang bisa memperbaiki lalu mengajukan ulang.</p>
            <textarea placeholder="Alasan penolakan (opsional)..." value={alasan} onChange={e => setAlasan(e.target.value)}
              style={{ width: '100%', minHeight: 80, background: colors.bgCardMuted, border: `1px solid ${colors.border}`, borderRadius: 8, color: colors.textPrimary, padding: '8px 12px', fontSize: 13, resize: 'vertical', boxSizing: 'border-box', marginBottom: 16 }} />
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setTolak(null)} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: `1px solid ${colors.borderStrong}`, background: colors.bgCard, color: colors.textPrimary, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Batal</button>
              <button onClick={() => kirim(tolak.id, 'tolak', alasan.trim() || null)} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: 'none', background: colors.danger, color: '#FFFFFF', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>Tolak Video</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function Approval({ ugcAktif }) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [processingId, setProcessingId] = useState(null);
  const [rejectModal, setRejectModal] = useState(null); // job object atau null
  const [rejectReason, setRejectReason] = useState('');
  const [videoUrls, setVideoUrls] = useState({});
  const [ugcCount, setUgcCount] = useState(0);

  const fetchQueue = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/api/jobs/pending-approval`);
      const list = res.data || [];
      setJobs(list);
      // Fetch preview video sebagai blob untuk job bertipe direct-upload (butuh auth, tidak bisa via <video src> biasa)
      list.filter(j => j.job_type === 'direct').forEach(async (j) => {
        try {
          const vidRes = await axios.get(`${API}/api/jobs/${j.id}/preview`, { responseType: 'blob' });
          const url = URL.createObjectURL(vidRes.data);
          setVideoUrls(prev => ({ ...prev, [j.id]: url }));
        } catch (e) {
          // Preview gagal dimuat, tidak fatal — cukup tidak tampilkan video untuk job ini
        }
      });
    } catch (e) {
      setError(e.response?.data?.error || 'Gagal memuat antrian persetujuan');
    }
    setLoading(false);
  };

  useEffect(() => { fetchQueue(); }, []);

  const approve = async (id) => {
    setProcessingId(id);
    try {
      await axios.put(`${API}/api/jobs/${id}/approve`);
      fetchQueue();
    } catch (e) {
      setError(e.response?.data?.error || 'Gagal menyetujui konten');
    }
    setProcessingId(null);
  };

  const submitReject = async () => {
    if (!rejectModal) return;
    setProcessingId(rejectModal.id);
    try {
      await axios.put(`${API}/api/jobs/${rejectModal.id}/reject`, { reason: rejectReason.trim() || null });
      setRejectModal(null);
      setRejectReason('');
      fetchQueue();
    } catch (e) {
      setError(e.response?.data?.error || 'Gagal menolak konten');
    }
    setProcessingId(null);
  };

  return (
    <div style={{ paddingBottom: 40 }}>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: colors.textPrimary, display: 'flex', alignItems: 'center', gap: 8 }}>
          <i className="ti ti-clipboard-check" style={{ fontSize: 22 }}></i>Persetujuan Konten
        </h1>
        <p style={{ fontSize: 13, color: colors.textSecondary, marginTop: 2 }}>Konten yang diupload anggota tim menunggu review sebelum tayang.</p>
      </div>

      {error && (
        <div style={{ padding: '10px 14px', background: colors.dangerMuted, color: colors.danger, borderRadius: radius.md, marginBottom: 16, fontSize: 13 }}>{error}</div>
      )}

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: colors.textSecondary }}>Memuat antrian...</div>
      ) : jobs.length === 0 && ugcCount === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: colors.textSecondary, background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg }}>
          <i className="ti ti-circle-check" style={{ fontSize: 40, marginBottom: 10, display: 'block', color: colors.success }}></i>
          Tidak ada konten yang menunggu persetujuan.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {jobs.map(job => (
            <div key={job.id} style={{ background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg, padding: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
                <div style={{ flex: 1, minWidth: 200 }}>
                  <div style={{ fontWeight: 600, fontSize: 14, color: colors.textPrimary, marginBottom: 4 }}>{job.title || 'Tanpa Judul'}</div>
                  <div style={{ fontSize: 11, color: colors.textSecondary }}>
                    Diajukan oleh <strong>{job.submitted_by_name || 'Tidak diketahui'}</strong> · {new Date(job.created_at).toLocaleString('id-ID')}
                  </div>
                  {job.youtube_url && (
                    <a href={job.youtube_url} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: colors.accent, display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 4 }}>
                      <i className="ti ti-external-link" style={{ fontSize: 12 }}></i>Lihat sumber video
                    </a>
                  )}
                  {job.job_type === 'direct' && (
                    videoUrls[job.id] ? (
                      <video controls preload="metadata" src={videoUrls[job.id]} style={{ width: '100%', maxWidth: 360, borderRadius: 8, marginTop: 8, display: 'block' }} />
                    ) : (
                      <div style={{ fontSize: 11, color: colors.textSecondary, marginTop: 8 }}>Memuat preview video...</div>
                    )
                  )}
                </div>
                <span style={{ fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 6, background: colors.warningMuted, color: colors.warning, textTransform: 'uppercase', flexShrink: 0 }}>{job.platforms}</span>
              </div>
              {job.description && (
                <div style={{ fontSize: 12, color: colors.textSecondary, background: colors.bgCardMuted, borderRadius: 8, padding: 10, marginBottom: 12, maxHeight: 60, overflow: 'auto' }}>{job.description}</div>
              )}
              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={() => approve(job.id)} disabled={processingId === job.id}
                  style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: 'none', background: processingId === job.id ? colors.border : colors.success, color: '#FFFFFF', fontSize: 13, fontWeight: 700, cursor: processingId === job.id ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                  <i className="ti ti-check" style={{ fontSize: 15 }}></i>Setujui
                </button>
                <button onClick={() => { setRejectModal(job); setRejectReason(''); }} disabled={processingId === job.id}
                  style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: `1px solid ${colors.danger}`, background: 'transparent', color: colors.danger, fontSize: 13, fontWeight: 700, cursor: processingId === job.id ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                  <i className="ti ti-x" style={{ fontSize: 15 }}></i>Tolak
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {ugcAktif && <UgcApprovals onError={setError} onChange={setUgcCount} />}

      {rejectModal && (
        <div onClick={() => setRejectModal(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: colors.bgCard, borderRadius: radius.lg, padding: 24, maxWidth: 400, width: '100%' }}>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: colors.textPrimary, marginBottom: 6 }}>Tolak Konten</h2>
            <p style={{ fontSize: 12, color: colors.textSecondary, marginBottom: 14 }}>"{rejectModal.title || 'Tanpa Judul'}" akan ditandai ditolak. Alasan ini akan terlihat oleh yang mengajukan.</p>
            <textarea placeholder="Alasan penolakan (opsional)..." value={rejectReason} onChange={e => setRejectReason(e.target.value)}
              style={{ width: '100%', minHeight: 80, background: colors.bgCardMuted, border: `1px solid ${colors.border}`, borderRadius: 8, color: colors.textPrimary, padding: '8px 12px', fontSize: 13, resize: 'vertical', boxSizing: 'border-box', marginBottom: 16 }} />
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setRejectModal(null)} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: `1px solid ${colors.borderStrong}`, background: colors.bgCard, color: colors.textPrimary, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Batal</button>
              <button onClick={submitReject} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: 'none', background: colors.danger, color: '#FFFFFF', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>Tolak Konten</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
